<template>
  <div
    :class="classMap"
    class="row stats">
    <div
      v-for="(stat, key) in items"
      :class="{ 'stacked': stacked }"
      :key="key"
      class="card-deck stats-stat">
      <BaseCard
        class="text-center mb-4 mx-4">
        <h5 class="card-title h3">
          <strong>{{ stat.stat }}</strong>
          <small
            v-if="stat.small"
            class="d-block pt-1">{{ stat.small }}</small>
        </h5>
        <div :class="{ 'spacing': spacing && !stat.small }">
          {{ stat.text }}
        </div>
      </BaseCard>
    </div>
  </div>
</template>

<script>
import BaseCard from './BaseCard.vue'

export default {
  name: 'StatRow',

  components: {
    BaseCard
  },

  props: {
    items: { default: () => [], type: Array },
    right: Boolean,
    stacked: Boolean
  },

  computed: {
    classMap () {
      const { right } = this

      return {
        'justify-content-center': !right,
        'justify-content-end': right
      }
    },

    spacing () {
      for (const i in this.items) {
        if (typeof this.items[i].small === 'string' && this.items[i].small !== '') {
          return true
        }
      }

      return false
    }
  }
}
</script>

<style>
    .stacked {
        width: 100%;
    }
    .spacing {
        padding-top: 21px;
    }
</style>
